import React from 'react';
import { motion } from 'framer-motion';
import { LightningIcon, PhoneIcon } from './Icons';
export const EmergencyCTA = () => {
  return <section className="relative py-20 text-white overflow-hidden" data-id="element-44">
      {/* Background Image */}
      <div className="absolute inset-0 z-0" data-id="element-45">
        <img src="https://cdn.magicpatterns.com/uploads/i6GtqD5ApKbyXj6LQ1mhqW/coast2.png" alt="Emergency tree removal at night" className="w-full h-full object-cover object-center" data-id="element-46" />
        <div className="absolute inset-0 bg-accent/80 mix-blend-multiply" data-id="element-47"></div>
        <div className="absolute inset-0 bg-black/30" data-id="element-48"></div>
      </div>

      <div className="relative z-10 max-w-5xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-49">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="flex flex-col md:flex-row items-center justify-between gap-10" data-id="element-50">
          <div className="flex-1 text-center md:text-left" data-id="element-51">
            <div className="inline-flex items-center gap-2 bg-white/20 backdrop-blur-sm px-4 py-2 rounded-full font-bold text-sm uppercase tracking-wider mb-6" data-id="element-52">
              <LightningIcon className="w-5 h-5" data-id="element-53" />
              Emergency? We're on our way
            </div>
            <h2 className="text-3xl md:text-4xl font-black mb-6 leading-tight drop-shadow-lg" data-id="element-54">
              Storm knocked a tree into your driveway?
              <br data-id="element-55" />
              Branch fell on your fence at midnight?
            </h2>
            <p className="text-xl font-medium text-white/90 mb-2" data-id="element-56">
              Don't wait. Don't stress. Call us right now.
            </p>
            <p className="text-white/80" data-id="element-57">
              We provide emergency tree service for exactly these situations —
              because trees don't wait for business hours, and neither do we.
            </p>
          </div>

          <div className="flex-shrink-0" data-id="element-58">
            <a href="tel:9093717021" className="flex flex-col items-center justify-center bg-white text-accent hover:bg-gray-50 px-10 py-6 rounded-2xl font-black transition-transform transform hover:scale-105 shadow-2xl" data-id="element-59">
              <span className="text-sm text-gray-500 uppercase tracking-widest mb-2 font-bold" data-id="element-60">
                Call 24/7
              </span>
              <div className="flex items-center gap-3 text-3xl" data-id="element-61">
                <PhoneIcon className="w-8 h-8" data-id="element-62" />
                (909) 371-7021
              </div>
            </a>
          </div>
        </motion.div>
      </div>
    </section>;
};